import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Link, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { formatISO } from 'date-fns';

const styleSheet = theme => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    [theme.breakpoints.up('sm')]: {
      tblCellDateCol: {
        paddingLeft: 10,
        paddingRight: 10,
        width: 50,
      },
      tblCellAppCol: {
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 200,
        width: 250,
      }
    },
    [theme.breakpoints.up('xs')]: {
      tblCellDateCol: {

      },
      tblCellAppCol: {

      }
    },

});

class CustomerAppAuditList extends React.Component {
  goTo(url) {
    if (url == null)
      return;
          
    this.props.history.push(`/${url}`);
   }        

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.al.nodes;


    return (
    <div className={classes.paper}>
    <TableContainer>
      <Table>
        <TableHead className={classes.tblHead}>
          <TableRow className={classes.tblHeadRow}>
            <TableCell className={classes.tblHeadCell}>Timestamp</TableCell>
            <TableCell className={classes.tblHeadCell}>Type</TableCell>
            <TableCell className={classes.tblHeadCell}>Changed by</TableCell>
            <TableCell className={classes.tblHeadCell}>Account</TableCell>
            <TableCell className={classes.tblHeadCell}>Detail</TableCell>
             
          </TableRow>
        </TableHead>
        <TableBody>
          { thenodes.map(n => {
           
            let orderId = n.orderId;
            let url;
            if (orderId) {
              url = 'subscriptionorderview?orderId=' + orderId;
            }

            //created time is unzoned, need to declare it as utc.
            let atime = formatISO(new Date(n.created+'Z'));

            let auditType = '';
            switch(n.auditType) {
              case 0:
                auditType = 'Created';
                break;
              case 1:
                auditType = 'Terms change';
                break;
              case 3:
                auditType = 'SO lifecycle';
                break;
              case 4:
                auditType = 'Status change';
                break;
              case 6:
                auditType = 'Other update';
                break;              
              default:
                auditType = 'Other update';
                break;                      
              }

            return (
              <TableRow key={n.customerAppAuditId} >
                <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}>{atime}</TableCell>
                {orderId &&
                <TableCell>
                  <Link component="button" 
                    variant="body2"
                    className={classes.inactive}
                    onClick={this.goTo.bind(this, url)}>
                    {auditType}
                  </Link>
                </TableCell>
                }
                {!orderId &&
                <TableCell>{auditType}</TableCell>
                }
                <TableCell>{n.userFirstname + ' ' + n.userLastname}</TableCell>
                <TableCell>{n.auditAccountName}</TableCell>
                <TableCell>{n.auditDetail}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
    );
  } // end render()
}

CustomerAppAuditList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(CustomerAppAuditList), { al: graphql`
  fragment CustomerAppAuditList_al on CustomerAppAuditEntriesConnection {

    nodes {
      customerAppAuditId
      auditAccountId
      auditAccountName
      userId
      userFirstname
      userLastname
      auditType
      auditDetail
      orderId
      created
    }
  }
` });
